import LP from '../0-lp';
import $ from 'jquery';

LP.pollActions = {
  init: function () {
    const $button = $('a[target="#lp-inner-content"][tab="pollactions"]');
    if (!$button.is('[disabled]')) {
      $('#lp-poll-nav-bar a.sublink').removeClass('active');
      $button.addClass('active');
    }
    LP.dlgRandomSelection.prepare('a[dialog="newRandomSelection"]', {
      afterSubmit: function () {
        LP.pollActions.reloadActions();
      },
    });
    LP.dlgResponseAction.prepare('a[dialog="newResponseAction"]', {
      afterSubmit: function () {
        LP.pollActions.reloadActions();
      },
    });
    LP.pollActions.cbReloadActions();
  },

  reloadActions: function () {
    let $wrapper = $('#pollactions-wrapper');
    window.Browser.loadHTML($wrapper, 'backend/getPollActionsTable/', 'poll=' + $wrapper.data('poll'), LP.pollActions.cbReloadActions);
  },

  cbReloadActions: function () {
    LP.dlgRandomSelection.prepare('#pollactionsPage a[dialog="randomSelection"]', {
      afterSubmit: function () {
        LP.pollActions.reloadActions();
      },
    });

    LP.dlgResponseAction.prepare('#pollactionsPage a[dialog="responseAction"]', {
      afterSubmit: function () {
        LP.pollActions.reloadActions();
      },
    });

    $('#pollactionsPage a[action="deleteAction"]').click(function () {
      if (!$(this).is('[disabled]')) {
        LP.pollActions.deleteAction(this);
      }
      return false;
    });
  },

  deleteAction: function (anchor) {
    var $this = $(anchor);
    var url = $this.attr('url');
    var params = $this.attr('url_params');
    if (!url && !params) {
      return;
    }

    LP.UI.warnConfirm(anchor, function () {
      window.Browser.send(url, params, LP.pollActions.reloadActions, LP.pollActions.reloadActions);
    });
  },
};
